import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicRouteStrategy, provideIonicAngular, IonApp, IonHeader, IonButton, IonIcon, IonTitle, IonContent, IonRouterOutlet, IonMenu, IonItem, IonLabel, IonToggle, IonFooter } from '@ionic/angular/standalone';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!

import { initializeApp } from 'firebase/app';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ComponentsModule } from 'src/components/components.module';
import { PipesModule } from 'src/pipes/pipes.module';


@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        IonApp,
        IonHeader,
        IonButton,
        IonIcon,
        IonTitle,
        IonContent,
        IonRouterOutlet,
        IonMenu,
        IonItem,
        IonLabel,
        PipesModule,
        IonToggle,
        IonFooter
    ],
    exports: [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        CurrencyPipe,
        DatePipe,
        provideIonicAngular()
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
        initializeApp(environment.firebase)
    }
}
